/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "location-c4948146--sprite",
  "use": "location-c4948146--sprite-usage",
  "viewBox": "0 0 23 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 23\" id=\"location-c4948146--sprite\"><path d=\"M11.5 0C7.099 0 3.518 3.58 3.518 7.982c0 4.237 7.242 14.134 7.55 14.553l.288.392a.178.178 0 00.288 0l.288-.392c.308-.419 7.55-10.316 7.55-14.553C19.482 3.581 15.9 0 11.5 0zm0 5.123a2.862 2.862 0 012.859 2.859 2.863 2.863 0 01-2.86 2.86 2.863 2.863 0 01-2.859-2.86 2.863 2.863 0 012.86-2.86z\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
